import { round } from 'lodash'
import { isBookingManager, isIT, isViewer } from './auth'
import { Role } from '@api'
export { fmtCurrency, fmtNumber } from './numberFormat'
export * from './date'
export { removeProperty } from './removeProperty'
export { default as getCurrentUserFloorId } from './getCurrentUserFloorId'
export { default as Nav } from './navigator'
export * from './space'
export * from './auth'
export * from './weekdays'
export * from './goTo'
export * from './dateUtil'
export * from './density'
export * from './employee'

export { default as transformFileToBase64 } from './transformFileToBase64'

export const isFinder = (role: Role | undefined) =>
  isViewer(role) || isBookingManager(role) || isIT(role) || location.pathname.includes('/finder')

export const pluralize = (i: number, str?: string) => {
  const postfix = i === 1 ? '' : 's'
  return str ? `${str}${postfix}` : postfix
}

export const capitalizeStr = (str: string) => str.charAt(0).toUpperCase().concat(str.substring(1))

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

export const parseNumber = (str: string) => Number(str.replace(/[^0-9.-]+/g, ''))

export const EnumHelpers = {
  toValueArray<E>(Enum: any): E[] {
    return Object.values(Enum).map((value) => value as E)
  },
}

export const metersToFt = (meters: number, precision = 0) => {
  return round(meters * 3.28084, precision)
}

export const ftToMeters = (feet: number, precision = 0) => {
  return round(feet * 0.3048, precision)
}

export const sqFtToSqMeters = (sqFeet: number, precision = 0) => {
  return round(sqFeet * 0.092903, precision)
}

export const sqMetersToSqFt = (sqMeters: number, precision = 0) => {
  return round(sqMeters * 10.7639, precision)
}

export const getInitials = (name: string) => {
  return name
    .trim()
    .split(/\s(?!\()/)
    .reduce((result, s, i, arr) => {
      if (i === 0) {
        return [s[0].toUpperCase()]
      }

      if (i === arr.length - 1) {
        return [...result, s[0].toUpperCase()]
      }
      return result
    }, [] as string[])
    .join('')
}
